import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnaufPaletteSetService } from '../knauf-palette-set.service';
import { Project, ProjectType } from '../project';
import { ProjectService } from '../project.service';

@Component({
  selector: 'app-palettes-info',
  templateUrl: './palettes-info.component.html',
  styleUrls: ['./palettes-info.component.sass']
})
export class PalettesInfoComponent implements OnInit {
  title: string = "STWORZYLIŚMY 5 PALET, KTÓRE UŁATWIĄ CI WYBÓR KOLORU";
  subtitle: string = "Czy wiesz, że tynki strukturalne Knauf na elewacje są dostępne w prawie 800 różnych wariantach kolorystycznych? Bogactwo barw powoduje, że nie wiadomo, na jakie kolory się zdecydować. Podpowiemy Ci, jak dobierać i łączyć ze sobą różne kolory oraz ich odcienie.";
  next: string = "/choose-palette"
  type: string;
  project: Project
  constructor(private projectService: ProjectService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.next += "/" + this.route.snapshot.paramMap.get('type');

    if (this.project.projectType == ProjectType.user) {
      this.next = '/editor';
    }
  }

}
